import { IonCol, IonGrid, IonRow } from '@ionic/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import SubPageLayout from 'ui/layout/SubPageLayout';

interface StaticMarkdownViewProps {
  languages: Record<string, () => string>;
}

const StaticMarkdownView: React.FC<StaticMarkdownViewProps> = ({
  languages,
}) => {
  const { i18n } = useTranslation();
  const langFunc =
    languages[i18n.language] ||
    languages.en ||
    languages[Object.keys(languages)[0]];

  if (!langFunc) {
    throw new Error('No default translation provided');
  }

  return (
    <SubPageLayout className="static-page">
      <IonGrid>
        <IonRow>
          <IonCol size="12">
            <ReactMarkdown
              components={{
                h1: 'h1',
                h2: 'h2',
                h3: 'h3',
              }}
            >
              {langFunc()}
            </ReactMarkdown>
          </IonCol>
        </IonRow>
      </IonGrid>
    </SubPageLayout>
  );
};

export default StaticMarkdownView;
